export default function getRecurringTotalAmount({
  recurringTaxAmount = 0,
  recurringAmountExcludingTax = 0,
  recurringSubtotalAmount = 0,
}) {
  // if there are tax amounts, use those
  if (recurringAmountExcludingTax > 0) {
    return recurringAmountExcludingTax + recurringTaxAmount;
  }

  // otherwise, calculate the total amount
  let totalAmount = recurringSubtotalAmount;

  // return positive amount or zero
  return Math.max(totalAmount, 0);
}
